import API_CONSTANT from 'constants/apiConstant';
import { put, takeEvery, takeLatest } from 'redux-saga/effects';
import { triggerSendMoneyApiCallSuccess, triggerTxnStatusApiCall } from 'redux/actions';
import { triggerSendMoneyApiCallFailure } from 'redux/actions/Api/SendMoneyFlow/sendMoney';
import { TRIGGER_SEND_MONEY_API } from 'redux/actionTypes';
import { apiCall } from 'services';
import { ChangeHistory, nativeHandler } from 'utils';

function* triggerSendMoneyApiCall(actions) {
	const { data, callback } = actions;
	let api;
	try {
		api = yield apiCall({
			urlType: API_CONSTANT.URL_TYPE.POST_PE_V1,
			url: data['bankDetailMode'] ? API_CONSTANT.URL.SEND_MONEY_THROUGH_BANK : API_CONSTANT.URL.SEND_MONEY,
			data,
			method: 'POST',
			options: {
				restrictToast: true,
			},
		});
		if (api.data.data) {
			const apiData = api.data.data;
			if (apiData) {
				callback && callback(apiData);
				yield put(triggerSendMoneyApiCallSuccess(apiData));
				localStorage.setItem('txn', 'true');
				yield put(
					triggerTxnStatusApiCall({
						txnId: apiData?.['txnId'],
						path: 'home',
						pLLimitReducedModalVisibility: true,
					}),
				);
			}
		} else {
			callback && callback(api.data);
			yield put(triggerSendMoneyApiCallFailure(api.data));
			localStorage.setItem('txn', 'false');
		}
	} catch (error) {
		throw error;
	}
}

export default function* triggerSendMoneyApiCallSaga() {
	yield takeEvery(TRIGGER_SEND_MONEY_API, triggerSendMoneyApiCall);
}
